import {
    UPDATE_PROPERTYGROUP,
    UPDATE_PROPERTYGROUP_FAILURE,

    UPDATE_PROPERTYGROUP_LOCALISATION,
    UPDATE_PROPERTYGROUP_LOCALISATION_FAILURE,
    UPDATE_PROPERTYGROUP_LOCALISATION_SUCCESS,
} from 'store/actions/types';

export const updatePropertygroup = (payload) => {
    return {
        type: UPDATE_PROPERTYGROUP,
        payload: payload,
    };
};

export const updatePropertygroupFailure = (error) => {
    return {
        type: UPDATE_PROPERTYGROUP_FAILURE,
        error: error,
    };
};

export const updatePropertygroupLocalisation = (payload, response) => {
    return {
        type: UPDATE_PROPERTYGROUP_LOCALISATION,
        payload: payload,
        propertygroup: response,
    };
};

export const updatePropertygroupLocalisationFailure = (error) => {
    return {
        type: UPDATE_PROPERTYGROUP_LOCALISATION_FAILURE,
        error: error,
    };
};

export const updatePropertygroupLocalisationSuccess = (payload, response) => {
    return {
        type: UPDATE_PROPERTYGROUP_LOCALISATION_SUCCESS,
        payload: payload,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/propertygroups/updatePropertygroups.js